export default __webpack_public_path__ + "static/media/fruitsbackground.78e731b3.png";